module.exports = __webpack_public_path__ + "static/img/AT@2x.2a05474b.jpg";